.mobileAccordionContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
}
